<img src="../../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>
<h1 mat-dialog-title>No Email Address</h1>
<div mat-dialog-content style="position:relative;top:-60px;">
    <div>
        @if(data.isAgreementChecked){
            <p>You have checked the "Send Agreement Notification" to send the Parker a parking agreement.  However, there is no email address associated with this Parker Profile.</p>
            <p>Please add an email address for the Parker, or uncheck the "Send Agreement Notification".</p>

        }
      </div>
</div>
<div mat-dialog-actions>
  
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>
